module.exports = ["of","and","with","who","by","California","in","kids","children","at","in","boys","girls","while","the","2012","2013","2014","2015","2016","year","san","county","race","black","african-american","asian","latino","white","other","childhood"]


//////////////////
// WEBPACK FOOTER
// ./src/utilities/stopwords.json
// module id = 39
// module chunks = 0